import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import Loading from "components/Loading";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import { useState, useEffect, useRef } from "react";
import MDInput from "components/MDInput";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Autocomplete from '@mui/material/Autocomplete';
import apiClient from "Api"
import Alert from '@mui/material/Alert';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Link from '@mui/material/Link';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@mui/styles'
import TabContext from '@mui/lab/TabContext';
import TabList from "@mui/lab/TabList";
import TabPanel from '@mui/lab/TabPanel';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Paper from '@mui/material/Paper';
import { Tooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function Settings() {
    const [isLoading, setIsLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const { enqueueSnackbar } = useSnackbar();

    const [value, setValue] = useState("1");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [logo, setlogo] = useState(null);

    const [file, setFile] = useState(null);

    // Sinaliza pro submit que o lojista pediu pra remover o logo (sem selecionar um novo).
    const [removeLogo, setRemoveLogo] = useState(false);

    const fileInputRef = useRef(null);

    const [pixDiscountEnabled, setPixDiscountEnabled] = useState(false);
    const [boletoDiscountEnabled, setBoletoDiscountEnabled] = useState(false);

    function handleLogoFileChange(e) {
        const selectedFile = e.target.files[0];

        // Permite selecionar o mesmo arquivo de novo em seguida (o navegador não dispara
        // onChange se o value não mudar entre duas seleções).
        e.target.value = null;

        if (!selectedFile) return;

        if (selectedFile.size / 1024 > 300) {
            enqueueSnackbar('A imagem deve ter o tamanho máximo de 300k', { variant: "error" });
            return;
        }

        if (selectedFile.type !== "image/jpeg" && selectedFile.type !== "image/png") {
            enqueueSnackbar('Extensão da imagem inválida!', { variant: "error" });
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setlogo(reader.result);
            setFile(selectedFile);
            setRemoveLogo(false);
        };
        reader.readAsDataURL(selectedFile);
    }

    function handleRemoveLogo() {
        setlogo(null);
        setFile(null);
        setRemoveLogo(true);
    }

    const [hasInstallmentFee, setHasInstallmentFee] = useState(false);
    const handleIntallmentFeeChange = (event, newValue) => {
        setHasInstallmentFee(newValue);
        if (!newValue) {
            setFormData(prevState => ({
                ...prevState,
                creditCardData: {
                    ...prevState.creditCardData,
                    initialInstallmentWithTax: "",
                    installmentFees: []
                }
            }));
        }
    };

    const [hasInstallmentFeeCustom, setHasInstallmentFeeCustom] = useState(false);
    const handleIntallmentFeeChangeCustom = (event, newValue) => {
        setHasInstallmentFeeCustom(newValue);
        if (!newValue) {
            setFormData(prevState => ({
                ...prevState,
                customCreditCardData: {
                    ...prevState.customCreditCardData,
                    initialInstallmentWithTax: "",
                    installmentFees: []
                }
            }));
        }
    };

    const [hasInstallmentFeeEWallet, setHasInstallmentFeeEWallet] = useState(false);
    const handleIntallmentFeeChangeEWallet = (event, newValue) => {
        setHasInstallmentFeeEWallet(newValue);
        if (!newValue) {
            setFormData(prevState => ({
                ...prevState,
                customEwalletData: {
                    ...prevState.customEwalletData,
                    initialInstallmentWithTax: "",
                    installmentFees: []
                }
            }));
        }
    };

    const [formData, setFormData] = useState({
        shopifyDomain: "",
        merchantId: "",
        merchantKey: "",
        storeName: "",
        pixData: {
            id: "",
            provider: "",
            expirationInSeconds: 86400,
            status: "UNINSTALLED"
        },
        boletoData: {
            id: "",
            provider: "",
            boletoNumber: "",
            expirationInDays: "",
            assignor: "",
            identification: "",
            demonstrative: "",
            instructions: "",
            cashDiscount: "",
            status: "UNINSTALLED"
        },
        creditCardData: {
            id: "",
            provider: "",
            maxInstallments: "",
            minIntallmentValue: "",
            initialInstallmentWithTax: "",
            installmentFees: [],
            cashDiscount: "",
            verifyCardEnabled: false,
            verifyCardProceedOnInconclusive: false,
            retriesEnabled: false,
            retriesProvider: "",
            status: "UNINSTALLED"
        },
        customCreditCardData: {
            id: "",
            provider: "",
            maxInstallments: "",
            minIntallmentValue: "",
            initialInstallmentWithTax: "",
            installmentFees: [],
            cashDiscount: "",
            verifyCardEnabled: false,
            verifyCardProceedOnInconclusive: false,
            retriesEnabled: false,
            retriesProvider: "",
            status: "UNINSTALLED"
        },
        protectedCardData: {
            id: "",
            status: "UNINSTALLED"
        },
        customEwalletData: {
            id: "",
            provider: "",
            maxInstallments: "",
            minIntallmentValue: "",
            initialInstallmentWithTax: "",
            installmentFees: [],
            cashDiscount: "",
            verifyCardEnabled: false,
            verifyCardProceedOnInconclusive: false,
            retriesEnabled: false,
            retriesProvider: "",
            status: "UNINSTALLED"
        },
    })

    const hasInstalledApps =
        (formData.pixData?.status !== "UNINSTALLED") ||
        (formData.boletoData?.status !== "UNINSTALLED") ||
        (formData.creditCardData?.status !== "UNINSTALLED") ||
        (formData.customCreditCardData?.status !== "UNINSTALLED") ||
        (formData.protectedCardData?.status !== "UNINSTALLED") ||
        (formData.customEwalletData?.status !== "UNINSTALLED");

    const handleSubmit = (e) => {
        e.preventDefault();

        setIsLoading(true);

        let data = new FormData();

        if (file) {
            data.append('logo', file);
        } else if (removeLogo) {
            data.append('removeLogo', 'true');
        }

        data.append('tenantDTO', JSON.stringify(formData));

        apiClient.post("/tenants", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
            .then(response => {
                enqueueSnackbar('Configurações salvas!', { variant: "success" });
                setFile(null);
                setRemoveLogo(false);
                getConfig(true);
            }).catch((error) => {
                console.log(error);
                enqueueSnackbar(`Erro ao salvar configurações! (${error.response.data})`, { variant: "error" });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const isValid = (value) => {
        var ret = (value && value.toString().trim() !== "");

        return ret === true;
    }

    const pixProviders = [
        { id: 0, label: "Simulado" },
        { id: 1, label: "Cielo30" },
        { id: 2, label: "Bradesco2" },
        { id: 3, label: "BancoDoBrasil3" },
        { id: 4, label: "Cielo2" },
    ];

    const boletoProviders = [
        { id: 0, label: "Simulado" },
        { id: 1, label: "Braspag" },
        { id: 2, label: "Bradesco2" },
        { id: 3, label: "BancoDoBrasil2" },
        { id: 4, label: "ItauShopline" },
        { id: 5, label: "Itau2" },
        { id: 6, label: "Santander2" },
        { id: 7, label: "Caixa2" },
        { id: 8, label: "CitiBank2" },
        { id: 9, label: "BancoDoBrasil3" },
        { id: 10, label: "Itau3" },
    ];

    const creditcardProviders = [
        { id: 0, label: "Simulado" },
        { id: 1, label: "Cielo30" },
        { id: 2, label: "Getnet" },
        { id: 3, label: "Rede2" },
        { id: 4, label: "GlobalPayments" },
        { id: 5, label: "Stone" },
        { id: 6, label: "Safra2" },
        { id: 7, label: "PagSeguro" },
        { id: 8, label: "FirstData" },
        { id: 9, label: "Sub1" },
        { id: 10, label: "Banorte" },
        { id: 11, label: "Credibanco2" },
        { id: 12, label: "Transbank2" },
        { id: 13, label: "Banese" },
        { id: 14, label: "BrasilCard" },
        { id: 15, label: "CredSystem" },
        { id: 16, label: "Credz" },
        { id: 17, label: "DMCard" },
        { id: 18, label: "PagarMe"}
    ];

    const fraudAnalysisSequence = [
        { id: 0, label: "AuthorizeFirst" },
        { id: 1, label: "AnalyseFirst" }
    ];

    const fraudAnalysisSequenceCriteria = [
        { id: 0, label: "OnSuccess" },
        { id: 1, label: "Always" }
    ];

    const fraudAnalysisProvider = [
        { id: 0, label: "Cybersource" }
    ];

    const getConfig = (keepTab) => {
        setIsLoading(true);
        return apiClient.get(`/tenants`)
            .then(response => {
                setHasInstallmentFee(response.data.creditCardData?.initialInstallmentWithTax !== null && response.data.creditCardData?.installmentFees?.length > 0);

                setHasInstallmentFeeCustom(response.data.customCreditCardData?.initialInstallmentWithTax !== null && response.data.customCreditCardData?.installmentFees?.length > 0);

                setHasInstallmentFeeEWallet(response.data.customEwalletData?.initialInstallmentWithTax !== null && response.data.customEwalletData?.installmentFees?.length > 0);

                setFormData(response.data);

                if (response.data.logoUrl)
                    setlogo(response.data.logoUrl);

                if (keepTab === undefined || keepTab === false) {
                    const selectedTab = determineInitialTab(response.data);

                    setValue(selectedTab);
                }

                if (response.data.boletoData?.cashDiscount && response.data.boletoData?.cashDiscount > 0)
                    setBoletoDiscountEnabled(true);

                if (response.data.pixData?.cashDiscount && response.data.pixData?.cashDiscount > 0)
                    setPixDiscountEnabled(true);

                setIsLoading(false);
            }).catch((error) => {
                console.log(error);
                enqueueSnackbar(`${error}`, { variant: "error" });
            })
            .finally(() => {
                setIsLoading(false);
                setIsInitialLoad(false);
            });
    }

    const determineInitialTab = (data) => {
        const {
            fraudAnalysisData,
            pixData,
            boletoData,
            creditCardData,
            customCreditCardData,
            customEwalletData
        } = data;

        // Regra 1: Análise de Fraude pendente de configuração (Prioridade Máxima)
        const isFraudPending = fraudAnalysisData?.status !== 'UNINSTALLED' && fraudAnalysisData?.hasPendingConfig;
        if (isFraudPending) {
            if (creditCardData != null && creditCardData?.status !== 'UNINSTALLED' && !creditCardData?.shopifyReadinessNotified) return "3";
            if (customCreditCardData != null && customCreditCardData?.status !== 'UNINSTALLED' && !customCreditCardData?.shopifyReadinessNotified) return "4";
            if (customEwalletData != null && customEwalletData?.status !== 'UNINSTALLED' && !customEwalletData?.shopifyReadinessNotified) return "5";
        }

        // Mapeamento dos provedores de pagamento na ordem exata de preferência
        const paymentTabs = [
            { id: "1", config: pixData },
            { id: "2", config: boletoData },
            { id: "3", config: creditCardData },
            { id: "4", config: customCreditCardData },
            { id: "5", config: customEwalletData }
        ];

        // Regra 2: Prioriza a primeira extensão INSTALADA mas NÃO NOTIFICADA à Shopify (Readiness pending)
        const pendingNotificationTab = paymentTabs.find(tab =>
            tab.config && tab.config.status !== 'UNINSTALLED' && !tab.config.shopifyReadinessNotified
        );

        if (pendingNotificationTab) return pendingNotificationTab.id;

        // Regra 3: Fallback para a primeira extensão que estiver instalada (Status != UNINSTALLED)
        const activeTab = paymentTabs.find(tab =>
            tab.config && tab.config.status !== 'UNINSTALLED'
        );

        console.log(activeTab);

        if (activeTab) return activeTab.id;


        console.log(1);
        // Regra 4: Padrão (Fallback absoluto)
        return "1";
    };

    useEffect(() => {
        getConfig();
    }, []);

    const [installmentList, setInstallmentList] = useState([]);
    const [installmentListCustom, setInstallmentListCustom] = useState([]);
    const [installmentListEWallet, setInstallmentListEWallet] = useState([]);

    /*function handleChangeFee(index, value) {
        let fees = [...formData.creditCardData.installmentFees];

        var installmentFee = fees.find((x) => x.installment == index);

        if (installmentFee !== undefined)
            installmentFee.fee = value;
        else
            fees.push({ installment: index, fee: value });

        setFormData(prevState => ({
            ...prevState,
            creditCardData: {
                ...prevState.creditCardData,
                installmentFees: fees
            }
        }))
    }*/

    function handleChangeFee(paymentKey, index, value) {
        // 1. Pega as taxas atuais baseadas na chave
        const currentFees = formData[paymentKey].installmentFees;
        
        // 2. Busca o índice da parcela
        const feeIndex = currentFees.findIndex((x) => x.installment == index);

        // 3. Cria um novo array de taxas baseado na busca
        let newFees;
        
        if (feeIndex !== -1) {
            // Se achou, mapeia o array e cria um NOVO objeto para a parcela alterada
            newFees = currentFees.map((item, i) => 
                i === feeIndex ? { ...item, fee: value } : item
            );
        } else {
            // Se não achou, cria um novo array com o novo item no final
            newFees = [...currentFees, { installment: index, fee: value }];
        }

        // 4. Atualiza o estado dinamicamente
        setFormData(prevState => ({
            ...prevState,
            [paymentKey]: {
                ...prevState[paymentKey],
                installmentFees: newFees
            }
        }));
    }

    function handleChangeInitialInstallmentWithFee(initialInstallment, maxInstallments) {
        if (initialInstallment !== "" && initialInstallment !== null && (initialInstallment <= 0 || initialInstallment > 100))
            return;

        if (maxInstallments !== "" && maxInstallments !== null && (maxInstallments <= 0 || maxInstallments > 100))
            return;

        let initial = parseInt(initialInstallment);
        let max = parseInt(maxInstallments);

        let fees = formData.creditCardData?.installmentFees == undefined ? [] : [...formData.creditCardData?.installmentFees];
        let newFees = [];

        fees.map(a => {
            if (a.installment >= initial && a.installment <= max)
                newFees.push(a);
        });


        setFormData(prevState => ({
            ...prevState,
            creditCardData: {
                ...prevState.creditCardData,
                initialInstallmentWithTax: initial,
                installmentFees: newFees,
                maxInstallments: max
            }
        }));
    }

    function handleChangeInitialInstallmentWithFeeCustom(initialInstallment, maxInstallments) {
        if (initialInstallment !== "" && initialInstallment !== null && (initialInstallment <= 0 || initialInstallment > 100))
            return;

        if (maxInstallments !== "" && maxInstallments !== null && (maxInstallments <= 0 || maxInstallments > 100))
            return;

        let initial = parseInt(initialInstallment);
        let max = parseInt(maxInstallments);

        let fees = formData.customCreditCardData?.installmentFees == undefined ? [] : [...formData.customCreditCardData?.installmentFees];
        let newFees = [];

        fees.map(a => {
            if (a.installment >= initial && a.installment <= max)
                newFees.push(a);
        });


        setFormData(prevState => ({
            ...prevState,
            customCreditCardData: {
                ...prevState.customCreditCardData,
                initialInstallmentWithTax: initial,
                installmentFees: newFees,
                maxInstallments: max
            }
        }));
    }

    function handleChangeInitialInstallmentWithFeeEWallet(initialInstallment, maxInstallments) {
        if (initialInstallment !== "" && initialInstallment !== null && (initialInstallment <= 0 || initialInstallment > 100))
            return;

        if (maxInstallments !== "" && maxInstallments !== null && (maxInstallments <= 0 || maxInstallments > 100))
            return;

        let initial = parseInt(initialInstallment);
        let max = parseInt(maxInstallments);

        let fees = formData.customEwalletData?.installmentFees == undefined ? [] : [...formData.customEwalletData?.installmentFees];
        let newFees = [];

        fees.map(a => {
            if (a.installment >= initial && a.installment <= max)
                newFees.push(a);
        });

        setFormData(prevState => ({
            ...prevState,
            customEwalletData: {
                ...prevState.customEwalletData,
                initialInstallmentWithTax: initial,
                installmentFees: newFees,
                maxInstallments: max
            }
        }));
    }

    useEffect(() => {
        if (formData.creditCardData != null && formData.creditCardData.initialInstallmentWithTax != null && formData.creditCardData.initialInstallmentWithTax !== undefined && formData.creditCardData.initialInstallmentWithTax !== "") {
            let list = [];

            for (let i = formData.creditCardData.initialInstallmentWithTax; i <= formData.creditCardData.maxInstallments; i++) {
                list.push(
                    <Grid item xs={12} md={12} key={i}>
                        <MDInput type="number" label={"Juros parcelamento em " + i + "x"} fullWidth value={formData.creditCardData.installmentFees?.find((x) => x.installment == i) !== undefined ? formData.creditCardData.installmentFees.find((x) => x.installment == i).fee : ""}
                            required onChange={(event) => handleChangeFee('creditCardData', i, event.target.value)}
                            error={!isValid(formData.creditCardData.installmentFees?.find((x) => x.installment == i) !== undefined ? formData.creditCardData.installmentFees?.find((x) => x.installment == i).fee : "")}
                            success={isValid(formData.creditCardData.installmentFees?.find((x) => x.installment == i) !== undefined ? formData.creditCardData.installmentFees?.find((x) => x.installment == i).fee : "")}
                        />
                    </Grid>
                );
            }

            setInstallmentList(list);
        } else {
            setInstallmentList([]);
        }

        if (formData.customCreditCardData != null && formData.customCreditCardData.initialInstallmentWithTax != null && formData.customCreditCardData.initialInstallmentWithTax !== undefined && formData.customCreditCardData.initialInstallmentWithTax !== "") {
            let list = [];

            for (let i = formData.customCreditCardData.initialInstallmentWithTax; i <= formData.customCreditCardData.maxInstallments; i++) {
                list.push(
                    <Grid item xs={12} md={12} key={i}>
                        <MDInput type="number" label={"Juros parcelamento em " + i + "x"} fullWidth value={formData.customCreditCardData.installmentFees?.find((x) => x.installment == i) !== undefined ? formData.customCreditCardData.installmentFees.find((x) => x.installment == i).fee : ""}
                            required onChange={(event) => handleChangeFee('customCreditCardData', i, event.target.value)}
                            error={!isValid(formData.customCreditCardData.installmentFees?.find((x) => x.installment == i) !== undefined ? formData.customCreditCardData.installmentFees?.find((x) => x.installment == i).fee : "")}
                            success={isValid(formData.customCreditCardData.installmentFees?.find((x) => x.installment == i) !== undefined ? formData.customCreditCardData.installmentFees?.find((x) => x.installment == i).fee : "")}
                        />
                    </Grid>
                );
            }

            setInstallmentListCustom(list);
        } else {
            setInstallmentListCustom([]);
        }

        if (formData.customEwalletData != null && formData.customEwalletData.initialInstallmentWithTax != null && formData.customEwalletData.initialInstallmentWithTax !== undefined && formData.customEwalletData.initialInstallmentWithTax !== "") {
            let list = [];

            for (let i = formData.customEwalletData.initialInstallmentWithTax; i <= formData.customEwalletData.maxInstallments; i++) {
                list.push(
                    <Grid item xs={12} md={12} key={i}>
                        <MDInput type="number" label={"Juros parcelamento em " + i + "x"} fullWidth value={formData.customEwalletData.installmentFees?.find((x) => x.installment == i) !== undefined ? formData.customEwalletData.installmentFees.find((x) => x.installment == i).fee : ""}
                            required onChange={(event) => handleChangeFee('customEwalletData', i, event.target.value)}
                            error={!isValid(formData.customEwalletData.installmentFees?.find((x) => x.installment == i) !== undefined ? formData.customEwalletData.installmentFees?.find((x) => x.installment == i).fee : "")}
                            success={isValid(formData.customEwalletData.installmentFees?.find((x) => x.installment == i) !== undefined ? formData.customEwalletData.installmentFees?.find((x) => x.installment == i).fee : "")}
                        />
                    </Grid>
                );
            }

            setInstallmentListEWallet(list);
        } else {
            setInstallmentListEWallet([]);
        }

        if (formData.pixData?.id && formData.pixData?.id != "")
            handlePixProviderChange(formData.pixData.provider);

    }, [formData]);


    const useStyles = makeStyles({
        autocomplete: {
            '& .MuiAutocomplete-inputRoot': {
                height: '44.125px', // Altura personalizada desejada
            },
        },
    });

    const classes = useStyles();

    const [pixExpirationActive, setPixExpirationActive] = useState(true);

    function handlePixProviderChange(provider) {
        if (provider == "Cielo30" || provider == "Cielo2") {
            setFormData(prevState => ({
                ...prevState,
                pixData: {
                    ...prevState.pixData,
                    expirationInSeconds: "7200"
                }
            }));
            setPixExpirationActive(false);
        }
        else {
            setPixExpirationActive(true);
        }
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading isLoading={isLoading}></Loading>
            <MDBox pt={3} pb={4}>
                <MDBox component="form" role="form" p={3} onSubmit={handleSubmit}>
                    <Grid container spacing={6} mb={3}>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={1.5}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Configurações
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={2} >
                                    <Loading isLoading={isLoading}></Loading>
                                    <MDBox p={3}>
                                        <MDBox mb={2}>
                                            <MDInput type="text" label="Shopify Domain" fullWidth value={formData.shopifyDomain} onChange={(e) => setFormData({ ...formData, merchantId: e.target.value })}
                                                disabled />
                                        </MDBox>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={4}>
                                                <MDInput type="text" label="MerchantId" fullWidth value={formData.merchantId || ""} onChange={(e) => setFormData({ ...formData, merchantId: e.target.value })} required
                                                    error={!isValid(formData.merchantId)} success={isValid(formData.merchantId)} />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <MDInput type="text" label="MerchantKey" fullWidth value={formData.merchantKey || ""} onChange={(e) => setFormData({ ...formData, merchantKey: e.target.value })} required
                                                    error={!isValid(formData.merchantKey)} success={isValid(formData.merchantKey)} />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <MDInput type="text" label="Nome da loja" fullWidth value={formData.storeName || ""} onChange={(e) => setFormData({ ...formData, storeName: e.target.value })} />
                                            </Grid>
                                            {((formData.pixData !== null && formData.pixData.status !== "UNINSTALLED") ||
                                                (formData.boletoData !== null && formData.boletoData.status !== "UNINSTALLED") ||
                                                (formData.creditCardData !== null && formData.creditCardData.status !== "UNINSTALLED") ||
                                                (formData.protectedCardData !== null && formData.protectedCardData.status !== "UNINSTALLED") ||
                                                (formData.customEwalletData !== null && formData.customEwalletData.status !== "UNINSTALLED")) &&
                                                <>
                                                    <Grid item xs={12} md={12}>
                                                        <Button
                                                            sx={{ color: 'white !important' }}
                                                            color="primary"
                                                            variant="contained"
                                                            startIcon={<CloudUploadIcon />}
                                                            onClick={() => fileInputRef.current?.click()}
                                                        >
                                                            Upload logo
                                                        </Button>
                                                        <input
                                                            ref={fileInputRef}
                                                            type="file"
                                                            accept="image/png,image/jpeg"
                                                            style={{ display: 'none' }}
                                                            onChange={handleLogoFileChange}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Alert severity="success" variant="outlined">
                                                            Utlize as extensões .jpg ou .png com tamanho máximo de 300k.
                                                        </Alert>
                                                    </Grid>
                                                    {logo && logo != null &&
                                                        <Grid item xs={12} md={12} >
                                                            <Paper elevation={3} sx={{ width: '200px', p: 1 }}>
                                                                <MDBox
                                                                    sx={{
                                                                        width: '100%',
                                                                        height: '120px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        overflow: 'hidden',
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={logo}
                                                                        alt="Preview"
                                                                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                                    />
                                                                </MDBox>
                                                                <Button
                                                                    color="error"
                                                                    size="small"
                                                                    startIcon={<DeleteOutlineIcon />}
                                                                    onClick={handleRemoveLogo}
                                                                    sx={{ mt: 1 }}
                                                                >
                                                                    Remover logo
                                                                </Button>
                                                            </Paper>
                                                        </Grid>}
                                                </>}
                                        </Grid>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                    </Grid>

                    {!isInitialLoad && hasInstalledApps && (
                        <Box sx={{ width: '100%' }} mb={3}>
                            <TabContext value={value}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label="basic tabs example">
                                        {formData.pixData !== null && formData.pixData.status !== "UNINSTALLED" && <Tab value="1" label="Pix" {...a11yProps(0)} icon={!formData.pixData.shopifyReadinessNotified ? (<WarningAmberIcon />) : (<></>)} />}
                                        {formData.boletoData !== null && formData.boletoData.status !== "UNINSTALLED" && <Tab value="2" label="Boleto" {...a11yProps(1)} icon={!formData.boletoData.shopifyReadinessNotified ? (<WarningAmberIcon />) : (<></>)} />}
                                        {formData.creditCardData !== null && formData.creditCardData.status !== "UNINSTALLED" && <Tab value="3" label="Cartão de crédito" {...a11yProps(2)} icon={!formData.creditCardData.shopifyReadinessNotified ? (<WarningAmberIcon />) : (<></>)} />}
                                        {formData.customCreditCardData !== null && formData.customCreditCardData.status !== "UNINSTALLED" && <Tab value="4" label="Cartão de crédito(Custom)" {...a11yProps(2)} icon={!formData.customCreditCardData.shopifyReadinessNotified ? (<WarningAmberIcon />) : (<></>)} />}
                                        {formData.customEwalletData !== null && formData.customEwalletData.status !== "UNINSTALLED" && <Tab value="5" label="E-Wallets(Custom)" {...a11yProps(2)} icon={!formData.customEwalletData.shopifyReadinessNotified ? (<WarningAmberIcon />) : (<></>)} />}
                                    </TabList >
                                </Box>
                                <Card>
                                    {formData.pixData !== null && formData.pixData.status !== "UNINSTALLED" &&
                                        <TabPanel value="1">
                                            {/* PIX TAB */}
                                            <MDBox>
                                                <Grid container spacing={2}>
                                                    {
                                                        formData.pixData.shopifyReadinessNotified &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined" style={{ backgroundColor: "#ffd5b9" }}>
                                                                <Link target="_blank" href={formData.pixData.shopifyActivationUrl} underline="always"><strong>Clique aqui para ativar/inativar o Pix na Shopify.</strong></Link>
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    {
                                                        !formData.pixData.shopifyReadinessNotified &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined">
                                                                Finalize as configurações para ativar o pagamento na Shopify!
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    <Grid item xs={12} md={4}>
                                                        <Autocomplete
                                                            className={classes.autocomplete}
                                                            disableClearable
                                                            value={formData.pixData.provider || ""}
                                                            options={pixProviders}
                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                            onChange={(event, newValue) => {
                                                                setFormData(prevState => ({
                                                                    ...prevState,
                                                                    pixData: {
                                                                        ...prevState.pixData,
                                                                        provider: newValue.label
                                                                    }
                                                                }));
                                                                handlePixProviderChange(newValue.label);
                                                            }}
                                                            renderInput={(params) => <MDInput {...params} label="selecione o provider"
                                                                error={!isValid(formData.pixData.provider)} success={isValid(formData.pixData.provider)}
                                                                required p={6}
                                                            />}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        {(formData.pixData.provider != "Cielo30" || formData.pixData.provider != "Cielo2") &&
                                                            <MDInput type="number" label="Tempo expiração e segundos" value={formData.pixData.expirationInSeconds || ""}
                                                                onChange={(event) =>
                                                                    setFormData(prevState => ({
                                                                        ...prevState,
                                                                        pixData: {
                                                                            ...prevState.pixData,
                                                                            expirationInSeconds: event.target.value
                                                                        }
                                                                    }))}
                                                                error={!isValid(formData.pixData.expirationInSeconds)} success={isValid(formData.pixData.expirationInSeconds)}
                                                                fullWidth
                                                                required
                                                                disabled={!pixExpirationActive}
                                                            />}
                                                        {(formData.pixData.provider == "Cielo30" || formData.pixData.provider == "Cielo2") &&
                                                            <Alert variant="outlined" severity="info">Para o provider Cielo30 ou Cielo2 o tempo de expiração é de duas horas e não é parametrizavel.</Alert>
                                                        }
                                                    </Grid>
                                                    {pixDiscountEnabled &&
                                                        <Grid item xs={12} md={4}>
                                                            <MDInput type="number" label="Desconto à vista %" value={formData.pixData.cashDiscount || ""}
                                                                onChange={(event) =>
                                                                    setFormData(prevState => ({
                                                                        ...prevState,
                                                                        pixData: {
                                                                            ...prevState.pixData,
                                                                            cashDiscount: event.target.value
                                                                        }
                                                                    }))}
                                                                fullWidth
                                                            />
                                                        </Grid>}
                                                </Grid>
                                            </MDBox>
                                        </TabPanel>}
                                    {formData.boletoData !== null && formData.boletoData.status !== "UNINSTALLED" &&
                                        <TabPanel value="2">
                                            {/* BOLETO TAB */}
                                            <MDBox>
                                                <Grid container spacing={2}>
                                                    {
                                                        formData.boletoData.shopifyReadinessNotified &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined" style={{ backgroundColor: "#ffd5b9" }}>
                                                                <Link target="_blank" href={formData.boletoData.shopifyActivationUrl} underline="always"><strong>Clique aqui para ativar/inativar o Boleto na Shopify.</strong></Link>
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    {
                                                        !formData.boletoData.shopifyReadinessNotified &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined">
                                                                Finalize as configurações para ativar o pagamento na Shopify!
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    <Grid item xs={12} md={3}>
                                                        <Autocomplete
                                                            className={classes.autocomplete}
                                                            disableClearable
                                                            value={formData.boletoData.provider ?? ""}
                                                            options={boletoProviders}
                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                            onChange={(event, newValue) =>
                                                                setFormData(prevState => ({
                                                                    ...prevState,
                                                                    boletoData: {
                                                                        ...prevState.boletoData,
                                                                        provider: newValue.label
                                                                    }

                                                                }))}
                                                            renderInput={(params) => <MDInput {...params} label="selecione o provider"
                                                                error={!isValid(formData.boletoData.provider)} success={isValid(formData.boletoData.provider)}
                                                                required
                                                            />}
                                                        />
                                                    </Grid>
                                                    {boletoDiscountEnabled &&
                                                        <Grid item xs={12} md={3}>
                                                            <MDInput type="number" label="Desconto à vista %" value={formData.boletoData.cashDiscount || ""}
                                                                onChange={(event) =>
                                                                    setFormData(prevState => ({
                                                                        ...prevState,
                                                                        boletoData: {
                                                                            ...prevState.boletoData,
                                                                            cashDiscount: event.target.value
                                                                        }
                                                                    }))}
                                                                fullWidth
                                                            />
                                                        </Grid>}
                                                    <Grid item xs={12} md={3}>
                                                        <MDInput type="text" label="Nosso Número" fullWidth value={formData.boletoData.boletoNumber ?? ""} onChange={(event) =>
                                                            setFormData(prevState => ({
                                                                ...prevState,
                                                                boletoData: {
                                                                    ...prevState.boletoData,
                                                                    boletoNumber: event.target.value
                                                                }
                                                            }))} />
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <MDInput type="number" label="Dias para vencimento" fullWidth value={formData.boletoData.expirationInDays ?? ""} onChange={(event) =>
                                                            setFormData(prevState => ({
                                                                ...prevState,
                                                                boletoData: {
                                                                    ...prevState.boletoData,
                                                                    expirationInDays: event.target.value
                                                                }
                                                            }))} />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <MDInput type="text" label="Nome do cedente" fullWidth value={formData.boletoData.assignor ?? ""} onChange={(event) =>
                                                            setFormData(prevState => ({
                                                                ...prevState,
                                                                boletoData: {
                                                                    ...prevState.boletoData,
                                                                    assignor: event.target.value
                                                                }
                                                            }))} />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <MDInput type="text" label="CNPJ do Cedente" fullWidth value={formData.boletoData.identification ?? ""} onChange={(event) =>
                                                            setFormData(prevState => ({
                                                                ...prevState,
                                                                boletoData: {
                                                                    ...prevState.boletoData,
                                                                    identification: event.target.value
                                                                }
                                                            }))} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <MDInput type="text" multiline rows={3} label="Texto de demonstrativo" fullWidth value={formData.boletoData.demonstrative ?? ""} onChange={(event) =>
                                                            setFormData(prevState => ({
                                                                ...prevState,
                                                                boletoData: {
                                                                    ...prevState.boletoData,
                                                                    demonstrative: event.target.value
                                                                }
                                                            }))} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <MDInput type="text" multiline rows={3} label="Instruções do boleto" fullWidth value={formData.boletoData.instructions ?? ""} onChange={(event) =>
                                                            setFormData(prevState => ({
                                                                ...prevState,
                                                                boletoData: {
                                                                    ...prevState.boletoData,
                                                                    instructions: event.target.value
                                                                }
                                                            }))} />
                                                    </Grid>
                                                </Grid>
                                            </MDBox>
                                        </TabPanel>}
                                    {formData.creditCardData !== null && formData.creditCardData.status !== "UNINSTALLED" &&
                                        <TabPanel value="3">
                                            {/* CREDITCARD TAB */}
                                            <MDBox>
                                                <Grid container spacing={2}>
                                                    {
                                                        formData.creditCardData.shopifyReadinessNotified &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined" style={{ backgroundColor: "#ffd5b9" }}>
                                                                <Link target="_blank" href={formData.creditCardData.shopifyActivationUrl} underline="always"><strong>Clique aqui para ativar/inativar o Cartão de crédito na Shopify.</strong></Link>
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    {
                                                        (formData.creditCardData.shopifyReadinessNotified === null || !formData.creditCardData.shopifyReadinessNotified) &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined">
                                                                Finalize as configurações para ativar o pagamento na Shopify!
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    <Grid item xs={12} md={4}>
                                                        <Autocomplete
                                                            className={classes.autocomplete}
                                                            disableClearable
                                                            value={formData.creditCardData.provider || ""}
                                                            options={creditcardProviders}
                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                            onChange={(event, newValue) =>
                                                                setFormData(prevState => ({
                                                                    ...prevState,
                                                                    creditCardData: {
                                                                        ...prevState.creditCardData,
                                                                        provider: newValue.label
                                                                    }

                                                                }))}
                                                            renderInput={(params) => <MDInput {...params} label="selecione o provider"
                                                                error={!isValid(formData.creditCardData.provider)} success={isValid(formData.creditCardData.provider)}
                                                                required
                                                            />}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDInput type="number" label="Número máximo de parcelas" fullWidth value={formData.creditCardData.maxInstallments || ""} onChange={(event) => {
                                                            handleChangeInitialInstallmentWithFee(formData.creditCardData.initialInstallmentWithTax, event.target.value);
                                                        }}
                                                            error={!isValid(formData.creditCardData.maxInstallments)} success={isValid(formData.creditCardData.maxInstallments)}
                                                            required />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDInput type="number" label="Valor mínimo das parcelas" fullWidth value={formData.creditCardData.minIntallmentValue || ""} onChange={(event) =>
                                                            setFormData(prevState => ({
                                                                ...prevState,
                                                                creditCardData: {
                                                                    ...prevState.creditCardData,
                                                                    minIntallmentValue: event.target.value
                                                                }
                                                            }))}
                                                            error={!isValid(formData.creditCardData.minIntallmentValue)} success={isValid(formData.creditCardData.minIntallmentValue)}
                                                            required />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch checked={hasInstallmentFee} onChange={handleIntallmentFeeChange} name="gilad" color="secondary" />
                                                                }
                                                                label="Habilitar parcelamento com juros"
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                    {
                                                        hasInstallmentFee &&
                                                        <>
                                                            <Grid item xs={12} md={8}>
                                                                <MDInput type="number" label="Parcelamento inicial com juros" fullWidth value={formData.creditCardData.initialInstallmentWithTax || ""} onChange={(event) => {
                                                                    handleChangeInitialInstallmentWithFee(event.target.value, formData.creditCardData.maxInstallments);
                                                                }}
                                                                    error={!isValid(formData.creditCardData.initialInstallmentWithTax)} success={isValid(formData.creditCardData.initialInstallmentWithTax)}
                                                                    required />
                                                            </Grid>
                                                            {installmentList}
                                                        </>
                                                    }

                                                    {
                                                        formData.fraudAnalysisData &&
                                                        formData.fraudAnalysisData !== null &&
                                                        formData.fraudAnalysisData?.status !== "UNINSTALLED" &&
                                                        <>
                                                            <Grid item xs={12} md={12}>
                                                                <MDTypography variant="h6">
                                                                    Análise de risco
                                                                </MDTypography>
                                                                <FormGroup>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch checked={formData.creditCardData.fraudAnalysisEnabled || false} onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    creditCardData: {
                                                                                        ...prevState.creditCardData,
                                                                                        fraudAnalysisEnabled: newValue
                                                                                    }
                                                                                }))}
                                                                                name="gilad" color="secondary" />
                                                                        }
                                                                        label="Habilitar"
                                                                    />
                                                                </FormGroup>
                                                            </Grid>
                                                            {formData.creditCardData.fraudAnalysisEnabled && (
                                                                <>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Autocomplete
                                                                            className={classes.autocomplete}
                                                                            disableClearable
                                                                            value={formData.creditCardData.fraudAnalysisSequence || ""}
                                                                            options={fraudAnalysisSequence}
                                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                            onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    creditCardData: {
                                                                                        ...prevState.creditCardData,
                                                                                        fraudAnalysisSequence: newValue.label
                                                                                    }
                                                                                }))}
                                                                            renderInput={(params) => <MDInput {...params} label="selecione a sequência"
                                                                                error={!isValid(formData.creditCardData.fraudAnalysisSequence)} success={isValid(formData.creditCardData.fraudAnalysisSequence)}
                                                                                required
                                                                            />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Autocomplete
                                                                            className={classes.autocomplete}
                                                                            disableClearable
                                                                            value={formData.creditCardData.fraudAnalysisSequenceCriteria || ""}
                                                                            options={fraudAnalysisSequenceCriteria}
                                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                            onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    creditCardData: {
                                                                                        ...prevState.creditCardData,
                                                                                        fraudAnalysisSequenceCriteria: newValue.label
                                                                                    }
                                                                                }))}
                                                                            renderInput={(params) => <MDInput {...params} label="selecione o critério"
                                                                                error={!isValid(formData.creditCardData.fraudAnalysisSequenceCriteria)} success={isValid(formData.creditCardData.fraudAnalysisSequenceCriteria)}
                                                                                required
                                                                            />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Autocomplete
                                                                            className={classes.autocomplete}
                                                                            disableClearable
                                                                            value={formData.creditCardData.fraudAnalysisProvider || ""}
                                                                            options={fraudAnalysisProvider}
                                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                            onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    creditCardData: {
                                                                                        ...prevState.creditCardData,
                                                                                        fraudAnalysisProvider: newValue.label
                                                                                    }
                                                                                }))}
                                                                            renderInput={(params) => <MDInput {...params} label="selecione o provider"
                                                                                error={!isValid(formData.creditCardData.fraudAnalysisProvider)} success={isValid(formData.creditCardData.fraudAnalysisProvider)}
                                                                                required
                                                                            />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <FormGroup>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Switch checked={formData.creditCardData.fraudAnalysisCaptureOnLowRisk || false} onChange={(event, newValue) =>
                                                                                        setFormData(prevState => ({
                                                                                            ...prevState,
                                                                                            creditCardData: {
                                                                                                ...prevState.creditCardData,
                                                                                                fraudAnalysisCaptureOnLowRisk: newValue
                                                                                            }
                                                                                        }))}
                                                                                        name="gilad" color="secondary" />
                                                                                }
                                                                                label="Capturar com baixo risco"
                                                                            />
                                                                        </FormGroup>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <FormGroup>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Switch checked={formData.creditCardData.fraudAnalysisVoidOnHighRisk} onChange={(event, newValue) => {
                                                                                        setFormData(prevState => ({
                                                                                            ...prevState,
                                                                                            creditCardData: {
                                                                                                ...prevState.creditCardData,
                                                                                                fraudAnalysisVoidOnHighRisk: newValue
                                                                                            }
                                                                                        }))
                                                                                    }}
                                                                                        name="gilad" color="secondary" />
                                                                                }
                                                                                label="Cancelar com alto risco"
                                                                            />
                                                                        </FormGroup>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </>
                                                    }
                                                    <Grid item xs={12} md={12}>
                                                        <MDTypography variant="h6">
                                                            Verify Card
                                                        </MDTypography>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch checked={formData.creditCardData.verifyCardEnabled || false} onChange={(event, newValue) => {
                                                                        setFormData(prevState => ({
                                                                            ...prevState,
                                                                            creditCardData: {
                                                                                ...prevState.creditCardData,
                                                                                verifyCardEnabled: newValue
                                                                            }
                                                                        }));

                                                                        if (!newValue) {
                                                                            setFormData(prevState => ({
                                                                                ...prevState,
                                                                                creditCardData: {
                                                                                    ...prevState.creditCardData,
                                                                                    verifyCardProceedOnInconclusive: false
                                                                                }
                                                                            }));
                                                                        }
                                                                    }}
                                                                        name="gilad" color="secondary" />
                                                                }
                                                                label="Habilitar"
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                    {formData.creditCardData.verifyCardEnabled &&
                                                        <Grid item xs={12} md={8}>
                                                            <FormGroup>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Switch checked={formData.creditCardData.verifyCardProceedOnInconclusive || false} onChange={(event, newValue) =>
                                                                            setFormData(prevState => ({
                                                                                ...prevState,
                                                                                creditCardData: {
                                                                                    ...prevState.creditCardData,
                                                                                    verifyCardProceedOnInconclusive: newValue
                                                                                }
                                                                            }))}
                                                                            name="gilad" color="secondary" />
                                                                    }
                                                                    label="Prosseguir caso status inconclusivo"
                                                                />
                                                            </FormGroup>
                                                        </Grid>
                                                    }

                                                    <Grid item xs={12} md={12}>
                                                        <MDTypography variant="h6">
                                                            Retentativa
                                                        </MDTypography>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch checked={formData.creditCardData.retriesEnabled || false} onChange={(event, newValue) => {
                                                                        setFormData(prevState => ({
                                                                            ...prevState,
                                                                            creditCardData: {
                                                                                ...prevState.creditCardData,
                                                                                retriesEnabled: newValue
                                                                            }
                                                                        }));

                                                                        if (!newValue) {
                                                                            setFormData(prevState => ({
                                                                                ...prevState,
                                                                                creditCardData: {
                                                                                    ...prevState.creditCardData,
                                                                                    retriesEnabled: false
                                                                                }
                                                                            }));
                                                                        }
                                                                    }}
                                                                        name="gilad" color="secondary" />
                                                                }
                                                                label="Habilitar"
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                    {formData.creditCardData.retriesEnabled &&
                                                        <>
                                                            <Grid item xs={12} md={4}>
                                                                <Autocomplete
                                                                    className={classes.autocomplete}
                                                                    value={formData.creditCardData.retriesProvider || ""}
                                                                    options={creditcardProviders}
                                                                    isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                    onChange={(event, newValue) =>
                                                                        setFormData(prevState => ({
                                                                            ...prevState,
                                                                            creditCardData: {
                                                                                ...prevState.creditCardData,
                                                                                retriesProvider: newValue ? newValue.label : newValue
                                                                            }

                                                                        }))}
                                                                    renderInput={(params) => <MDInput {...params} label="selecione o provider da Retentativa"
                                                                    />}
                                                                />
                                                            </Grid>
                                                            <Tooltip title="Campo não obrigatório, caso não for selecionado será mantido o provider da 1º tentativa." placement="top" arrow>
                                                                <IconButton size="small" sx={{ ml: 1, mt: 1 }}>
                                                                    <HelpOutlineIcon fontSize="small" color="disabled" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    }

                                                </Grid>
                                            </MDBox>
                                        </TabPanel>}
                                    {formData.customCreditCardData !== null && formData.customCreditCardData.status !== "UNINSTALLED" &&
                                        <TabPanel value="4">
                                            {/* CREDITCARD CUSTOM TAB */}
                                            <MDBox>
                                                <Grid container spacing={2}>
                                                    {
                                                        formData.customCreditCardData.shopifyReadinessNotified &&
                                                        <Grid item xs={12} mb={1}>
                                                            <Alert severity="warning" variant="outlined" style={{ backgroundColor: "#ffd5b9" }}>
                                                                <Link target="_blank" href={formData.customCreditCardData.shopifyActivationUrl} underline="always"><strong>Clique aqui para ativar/inativar o Cartão de crédito(Custom) na Shopify.</strong></Link>
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    {
                                                        formData.customCreditCardData.shopifyReadinessNotified && formData.protectedCardData?.shopifyReadinessNotified &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined" style={{ backgroundColor: "#ffd5b9" }}>
                                                                <Link target="_blank" href={formData.protectedCardData?.shopifyActivationUrl} underline="always"><strong>Clique aqui para ativar/inativar o Meus cartões na Shopify.</strong></Link>
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    {
                                                        (formData.customCreditCardData.shopifyReadinessNotified === null || !formData.customCreditCardData.shopifyReadinessNotified) &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined">
                                                                Finalize as configurações para ativar o pagamento na Shopify!
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    <Grid item xs={12} md={12}>
                                                        <MDInput type="text" label="Custom App Id" fullWidth value={formData.customCreditCardData.customApp?.id} disabled />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <Autocomplete
                                                            className={classes.autocomplete}
                                                            disableClearable
                                                            value={formData.customCreditCardData.provider || ""}
                                                            options={creditcardProviders}
                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                            onChange={(event, newValue) =>
                                                                setFormData(prevState => ({
                                                                    ...prevState,
                                                                    customCreditCardData: {
                                                                        ...prevState.customCreditCardData,
                                                                        provider: newValue.label
                                                                    }

                                                                }))}
                                                            renderInput={(params) => <MDInput {...params} label="selecione o provider"
                                                                error={!isValid(formData.customCreditCardData.provider)} success={isValid(formData.customCreditCardData.provider)}
                                                                required
                                                            />}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDInput type="number" label="Número máximo de parcelas" fullWidth value={formData.customCreditCardData.maxInstallments || ""} onChange={(event) => {
                                                            handleChangeInitialInstallmentWithFeeCustom(formData.customCreditCardData.initialInstallmentWithTax, event.target.value);
                                                        }}
                                                            error={!isValid(formData.customCreditCardData.maxInstallments)} success={isValid(formData.customCreditCardData.maxInstallments)}
                                                            required />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDInput type="number" label="Valor mínimo das parcelas" fullWidth value={formData.customCreditCardData.minIntallmentValue || ""} onChange={(event) =>
                                                            setFormData(prevState => ({
                                                                ...prevState,
                                                                customCreditCardData: {
                                                                    ...prevState.customCreditCardData,
                                                                    minIntallmentValue: event.target.value
                                                                }
                                                            }))}
                                                            error={!isValid(formData.customCreditCardData.minIntallmentValue)} success={isValid(formData.customCreditCardData.minIntallmentValue)}
                                                            required />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch checked={hasInstallmentFeeCustom} onChange={handleIntallmentFeeChangeCustom} name="gilad" color="secondary" />
                                                                }
                                                                label="Habilitar parcelamento com juros"
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                    {
                                                        hasInstallmentFeeCustom &&
                                                        <>
                                                            <Grid item xs={12} md={8}>
                                                                <MDInput type="number" label="Parcelamento inicial com juros" fullWidth value={formData.customCreditCardData.initialInstallmentWithTax || ""} onChange={(event) => {
                                                                    handleChangeInitialInstallmentWithFeeCustom(event.target.value, formData.customCreditCardData.maxInstallments);
                                                                }}
                                                                    error={!isValid(formData.customCreditCardData.initialInstallmentWithTax)} success={isValid(formData.customCreditCardData.initialInstallmentWithTax)}
                                                                    required />
                                                            </Grid>
                                                            {installmentListCustom}
                                                        </>
                                                    }

                                                    {
                                                        formData.fraudAnalysisData &&
                                                        formData.fraudAnalysisData !== null &&
                                                        formData.fraudAnalysisData?.status !== "UNINSTALLED" &&
                                                        <>
                                                            <Grid item xs={12} md={12}>
                                                                <MDTypography variant="h6">
                                                                    Análise de risco
                                                                </MDTypography>
                                                                <FormGroup>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch checked={formData.customCreditCardData.fraudAnalysisEnabled || false} onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    customCreditCardData: {
                                                                                        ...prevState.customCreditCardData,
                                                                                        fraudAnalysisEnabled: newValue
                                                                                    }
                                                                                }))}
                                                                                name="gilad" color="secondary" />
                                                                        }
                                                                        label="Habilitar"
                                                                    />
                                                                </FormGroup>
                                                            </Grid>
                                                            {formData.customCreditCardData.fraudAnalysisEnabled && (
                                                                <>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Autocomplete
                                                                            className={classes.autocomplete}
                                                                            disableClearable
                                                                            value={formData.customCreditCardData.fraudAnalysisSequence || ""}
                                                                            options={fraudAnalysisSequence}
                                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                            onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    customCreditCardData: {
                                                                                        ...prevState.customCreditCardData,
                                                                                        fraudAnalysisSequence: newValue.label
                                                                                    }
                                                                                }))}
                                                                            renderInput={(params) => <MDInput {...params} label="selecione a sequência"
                                                                                error={!isValid(formData.customCreditCardData.fraudAnalysisSequence)} success={isValid(formData.customCreditCardData.fraudAnalysisSequence)}
                                                                                required
                                                                            />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Autocomplete
                                                                            className={classes.autocomplete}
                                                                            disableClearable
                                                                            value={formData.customCreditCardData.fraudAnalysisSequenceCriteria || ""}
                                                                            options={fraudAnalysisSequenceCriteria}
                                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                            onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    customCreditCardData: {
                                                                                        ...prevState.customCreditCardData,
                                                                                        fraudAnalysisSequenceCriteria: newValue.label
                                                                                    }
                                                                                }))}
                                                                            renderInput={(params) => <MDInput {...params} label="selecione o critério"
                                                                                error={!isValid(formData.customCreditCardData.fraudAnalysisSequenceCriteria)} success={isValid(formData.customCreditCardData.fraudAnalysisSequenceCriteria)}
                                                                                required
                                                                            />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Autocomplete
                                                                            className={classes.autocomplete}
                                                                            disableClearable
                                                                            value={formData.customCreditCardData.fraudAnalysisProvider || ""}
                                                                            options={fraudAnalysisProvider}
                                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                            onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    customCreditCardData: {
                                                                                        ...prevState.customCreditCardData,
                                                                                        fraudAnalysisProvider: newValue.label
                                                                                    }
                                                                                }))}
                                                                            renderInput={(params) => <MDInput {...params} label="selecione o provider"
                                                                                error={!isValid(formData.customCreditCardData.fraudAnalysisProvider)} success={isValid(formData.customCreditCardData.fraudAnalysisProvider)}
                                                                                required
                                                                            />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <FormGroup>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Switch checked={formData.customCreditCardData.fraudAnalysisCaptureOnLowRisk || false} onChange={(event, newValue) =>
                                                                                        setFormData(prevState => ({
                                                                                            ...prevState,
                                                                                            customCreditCardData: {
                                                                                                ...prevState.customCreditCardData,
                                                                                                fraudAnalysisCaptureOnLowRisk: newValue
                                                                                            }
                                                                                        }))}
                                                                                        name="gilad" color="secondary" />
                                                                                }
                                                                                label="Capturar com baixo risco"
                                                                            />
                                                                        </FormGroup>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <FormGroup>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Switch checked={formData.customCreditCardData.fraudAnalysisVoidOnHighRisk} onChange={(event, newValue) => {
                                                                                        setFormData(prevState => ({
                                                                                            ...prevState,
                                                                                            customCreditCardData: {
                                                                                                ...prevState.customCreditCardData,
                                                                                                fraudAnalysisVoidOnHighRisk: newValue
                                                                                            }
                                                                                        }))
                                                                                    }}
                                                                                        name="gilad" color="secondary" />
                                                                                }
                                                                                label="Cancelar com alto risco"
                                                                            />
                                                                        </FormGroup>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </>
                                                    }
                                                    <Grid item xs={12} md={12}>
                                                        <MDTypography variant="h6">
                                                            Verify Card
                                                        </MDTypography>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch checked={formData.customCreditCardData.verifyCardEnabled || false} onChange={(event, newValue) => {
                                                                        setFormData(prevState => ({
                                                                            ...prevState,
                                                                            customCreditCardData: {
                                                                                ...prevState.customCreditCardData,
                                                                                verifyCardEnabled: newValue
                                                                            }
                                                                        }));

                                                                        if (!newValue) {
                                                                            setFormData(prevState => ({
                                                                                ...prevState,
                                                                                customCreditCardData: {
                                                                                    ...prevState.customCreditCardData,
                                                                                    verifyCardProceedOnInconclusive: false
                                                                                }
                                                                            }));
                                                                        }
                                                                    }}
                                                                        name="gilad" color="secondary" />
                                                                }
                                                                label="Habilitar"
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                    {formData.customCreditCardData.verifyCardEnabled &&
                                                        <Grid item xs={12} md={8}>
                                                            <FormGroup>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Switch checked={formData.customCreditCardData.verifyCardProceedOnInconclusive || false} onChange={(event, newValue) =>
                                                                            setFormData(prevState => ({
                                                                                ...prevState,
                                                                                customCreditCardData: {
                                                                                    ...prevState.customCreditCardData,
                                                                                    verifyCardProceedOnInconclusive: newValue
                                                                                }
                                                                            }))}
                                                                            name="gilad" color="secondary" />
                                                                    }
                                                                    label="Prosseguir caso status inconclusivo"
                                                                />
                                                            </FormGroup>
                                                        </Grid>
                                                    }

                                                    <Grid item xs={12} md={12}>
                                                        <MDTypography variant="h6">
                                                            Retentativa
                                                        </MDTypography>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch checked={formData.customCreditCardData.retriesEnabled || false} onChange={(event, newValue) => {
                                                                        setFormData(prevState => ({
                                                                            ...prevState,
                                                                            customCreditCardData: {
                                                                                ...prevState.customCreditCardData,
                                                                                retriesEnabled: newValue
                                                                            }
                                                                        }));

                                                                        if (!newValue) {
                                                                            setFormData(prevState => ({
                                                                                ...prevState,
                                                                                customCreditCardData: {
                                                                                    ...prevState.customCreditCardData,
                                                                                    retriesEnabled: false
                                                                                }
                                                                            }));
                                                                        }
                                                                    }}
                                                                        name="gilad" color="secondary" />
                                                                }
                                                                label="Habilitar"
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                    {formData.customCreditCardData.retriesEnabled &&
                                                        <>
                                                            <Grid item xs={12} md={4}>
                                                                <Autocomplete
                                                                    className={classes.autocomplete}
                                                                    value={formData.customCreditCardData.retriesProvider || ""}
                                                                    options={creditcardProviders}
                                                                    isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                    onChange={(event, newValue) =>
                                                                        setFormData(prevState => ({
                                                                            ...prevState,
                                                                            customCreditCardData: {
                                                                                ...prevState.customCreditCardData,
                                                                                retriesProvider: newValue ? newValue.label : newValue
                                                                            }

                                                                        }))}
                                                                    renderInput={(params) => <MDInput {...params} label="selecione o provider da Retentativa"
                                                                    />}
                                                                />
                                                            </Grid>
                                                            <Tooltip title="Campo não obrigatório, caso não for selecionado será mantido o provider da 1º tentativa." placement="top" arrow>
                                                                <IconButton size="small" sx={{ ml: 1, mt: 1 }}>
                                                                    <HelpOutlineIcon fontSize="small" color="disabled" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    }

                                                </Grid>
                                            </MDBox>
                                        </TabPanel>}
                                    {formData.customEwalletData !== null && formData.customEwalletData.status !== "UNINSTALLED" &&
                                        <TabPanel value="5">
                                            {/* EWALLETS TAB */}
                                            <MDBox>
                                                <Grid container spacing={2}>
                                                    {
                                                        formData.customEwalletData.shopifyReadinessNotified &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined" style={{ backgroundColor: "#ffd5b9" }}>
                                                                <Link target="_blank" href={formData.customEwalletData.shopifyActivationUrl} underline="always"><strong>Clique aqui para ativar/inativar a E-Wallets na Shopify.</strong></Link>
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    {
                                                        (formData.customEwalletData.shopifyReadinessNotified === null || !formData.customEwalletData.shopifyReadinessNotified) &&
                                                        <Grid item xs={12} mb={3}>
                                                            <Alert severity="warning" variant="outlined">
                                                                Finalize as configurações para ativar o pagamento na Shopify!
                                                            </Alert>
                                                        </Grid>
                                                    }
                                                    <Grid item xs={12} md={4}>
                                                        <Autocomplete
                                                            className={classes.autocomplete}
                                                            disableClearable
                                                            value={formData.customEwalletData.provider || ""}
                                                            options={creditcardProviders}
                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                            onChange={(event, newValue) =>
                                                                setFormData(prevState => ({
                                                                    ...prevState,
                                                                    customEwalletData: {
                                                                        ...prevState.customEwalletData,
                                                                        provider: newValue.label
                                                                    }

                                                                }))}
                                                            renderInput={(params) => <MDInput {...params} label="selecione o provider"
                                                                error={!isValid(formData.customEwalletData.provider)} success={isValid(formData.customEwalletData.provider)}
                                                                required
                                                            />}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDInput type="number" label="Número máximo de parcelas" fullWidth value={formData.customEwalletData.maxInstallments || ""} onChange={(event) => {
                                                            handleChangeInitialInstallmentWithFeeEWallet(formData.customEwalletData.initialInstallmentWithTax, event.target.value);
                                                        }}
                                                            error={!isValid(formData.customEwalletData.maxInstallments)} success={isValid(formData.customEwalletData.maxInstallments)}
                                                            required />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDInput type="number" label="Valor mínimo das parcelas" fullWidth value={formData.customEwalletData.minIntallmentValue || ""} onChange={(event) =>
                                                            setFormData(prevState => ({
                                                                ...prevState,
                                                                customEwalletData: {
                                                                    ...prevState.customEwalletData,
                                                                    minIntallmentValue: event.target.value
                                                                }
                                                            }))}
                                                            error={!isValid(formData.customEwalletData.minIntallmentValue)} success={isValid(formData.customEwalletData.minIntallmentValue)}
                                                            required />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch checked={hasInstallmentFeeEWallet} onChange={handleIntallmentFeeChangeEWallet} name="gilad" color="secondary" />
                                                                }
                                                                label="Habilitar parcelamento com juros"
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                    {
                                                        hasInstallmentFeeEWallet &&
                                                        <>
                                                            <Grid item xs={12} md={8}>
                                                                <MDInput type="number" label="Parcelamento inicial com juros" fullWidth value={formData.customEwalletData.initialInstallmentWithTax || ""} onChange={(event) => {
                                                                    handleChangeInitialInstallmentWithFeeEWallet(event.target.value, formData.customEwalletData.maxInstallments);
                                                                }}
                                                                    error={!isValid(formData.customEwalletData.initialInstallmentWithTax)} success={isValid(formData.customEwalletData.initialInstallmentWithTax)}
                                                                    required />
                                                            </Grid>
                                                            {installmentListEWallet}
                                                        </>
                                                    }

                                                    {
                                                        formData.fraudAnalysisData &&
                                                        formData.fraudAnalysisData !== null &&
                                                        formData.fraudAnalysisData?.status !== "UNINSTALLED" &&
                                                        <>
                                                            <Grid item xs={12} md={12}>
                                                                <MDTypography variant="h6">
                                                                    Análise de risco
                                                                </MDTypography>
                                                                <FormGroup>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch checked={formData.customEwalletData.fraudAnalysisEnabled || false} onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    customEwalletData: {
                                                                                        ...prevState.customEwalletData,
                                                                                        fraudAnalysisEnabled: newValue
                                                                                    }
                                                                                }))}
                                                                                name="gilad" color="secondary" />
                                                                        }
                                                                        label="Habilitar"
                                                                    />
                                                                </FormGroup>
                                                            </Grid>
                                                            {formData.customEwalletData.fraudAnalysisEnabled && (
                                                                <>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Autocomplete
                                                                            className={classes.autocomplete}
                                                                            disableClearable
                                                                            value={formData.customEwalletData.fraudAnalysisSequence || ""}
                                                                            options={fraudAnalysisSequence}
                                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                            onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    customEwalletData: {
                                                                                        ...prevState.customEwalletData,
                                                                                        fraudAnalysisSequence: newValue.label
                                                                                    }
                                                                                }))}
                                                                            renderInput={(params) => <MDInput {...params} label="selecione a sequência"
                                                                                error={!isValid(formData.customEwalletData.fraudAnalysisSequence)} success={isValid(formData.customEwalletData.fraudAnalysisSequence)}
                                                                                required
                                                                            />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Autocomplete
                                                                            className={classes.autocomplete}
                                                                            disableClearable
                                                                            value={formData.customEwalletData.fraudAnalysisSequenceCriteria || ""}
                                                                            options={fraudAnalysisSequenceCriteria}
                                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                            onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    customEwalletData: {
                                                                                        ...prevState.customEwalletData,
                                                                                        fraudAnalysisSequenceCriteria: newValue.label
                                                                                    }
                                                                                }))}
                                                                            renderInput={(params) => <MDInput {...params} label="selecione o critério"
                                                                                error={!isValid(formData.customEwalletData.fraudAnalysisSequenceCriteria)} success={isValid(formData.customEwalletData.fraudAnalysisSequenceCriteria)}
                                                                                required
                                                                            />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Autocomplete
                                                                            className={classes.autocomplete}
                                                                            disableClearable
                                                                            value={formData.customEwalletData.fraudAnalysisProvider || ""}
                                                                            options={fraudAnalysisProvider}
                                                                            isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                            onChange={(event, newValue) =>
                                                                                setFormData(prevState => ({
                                                                                    ...prevState,
                                                                                    customEwalletData: {
                                                                                        ...prevState.customEwalletData,
                                                                                        fraudAnalysisProvider: newValue.label
                                                                                    }
                                                                                }))}
                                                                            renderInput={(params) => <MDInput {...params} label="selecione o provider"
                                                                                error={!isValid(formData.customEwalletData.fraudAnalysisProvider)} success={isValid(formData.customEwalletData.fraudAnalysisProvider)}
                                                                                required
                                                                            />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <FormGroup>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Switch checked={formData.customEwalletData.fraudAnalysisCaptureOnLowRisk || false} onChange={(event, newValue) =>
                                                                                        setFormData(prevState => ({
                                                                                            ...prevState,
                                                                                            customEwalletData: {
                                                                                                ...prevState.customEwalletData,
                                                                                                fraudAnalysisCaptureOnLowRisk: newValue
                                                                                            }
                                                                                        }))}
                                                                                        name="gilad" color="secondary" />
                                                                                }
                                                                                label="Capturar com baixo risco"
                                                                            />
                                                                        </FormGroup>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <FormGroup>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Switch checked={formData.customEwalletData.fraudAnalysisVoidOnHighRisk} onChange={(event, newValue) => {
                                                                                        setFormData(prevState => ({
                                                                                            ...prevState,
                                                                                            customEwalletData: {
                                                                                                ...prevState.customEwalletData,
                                                                                                fraudAnalysisVoidOnHighRisk: newValue
                                                                                            }
                                                                                        }))
                                                                                    }}
                                                                                        name="gilad" color="secondary" />
                                                                                }
                                                                                label="Cancelar com alto risco"
                                                                            />
                                                                        </FormGroup>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </>
                                                    }

                                                    {/*<Grid item xs={12} md={12}>
                                                        <MDTypography variant="h6">
                                                            Retentativa
                                                        </MDTypography>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch checked={formData.customEwalletData.retriesEnabled || false} onChange={(event, newValue) => {
                                                                        setFormData(prevState => ({
                                                                            ...prevState,
                                                                            customEwalletData: {
                                                                                ...prevState.customEwalletData,
                                                                                retriesEnabled: newValue
                                                                            }
                                                                        }));

                                                                        if (!newValue) {
                                                                            setFormData(prevState => ({
                                                                                ...prevState,
                                                                                customEwalletData: {
                                                                                    ...prevState.customEwalletData,
                                                                                    retriesEnabled: false
                                                                                }
                                                                            }));
                                                                        }
                                                                    }}
                                                                        name="gilad" color="secondary" />
                                                                }
                                                                label="Habilitar"
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                    {formData.customEwalletData.retriesEnabled &&
                                                        <>
                                                            <Grid item xs={12} md={4}>
                                                                <Autocomplete
                                                                    className={classes.autocomplete}
                                                                    value={formData.customEwalletData.retriesProvider || ""}
                                                                    options={creditcardProviders}
                                                                    isOptionEqualToValue={(option, value) => option.label === value || value === ""}
                                                                    onChange={(event, newValue) =>
                                                                        setFormData(prevState => ({
                                                                            ...prevState,
                                                                            customEwalletData: {
                                                                                ...prevState.customEwalletData,
                                                                                retriesProvider: newValue ? newValue.label : newValue
                                                                            }

                                                                        }))}
                                                                    renderInput={(params) => <MDInput {...params} label="selecione o provider da Retentativa"
                                                                    />}
                                                                />
                                                            </Grid>
                                                            <Tooltip title="Campo não obrigatório, caso não for selecionado será mantido o provider da 1º tentativa." placement="top" arrow>
                                                                <IconButton size="small" sx={{ ml: 1, mt: 1 }}>
                                                                    <HelpOutlineIcon fontSize="small" color="disabled" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    }*/}

                                                </Grid>
                                            </MDBox>
                                        </TabPanel>}
                                </Card>
                            </TabContext>
                        </Box>
                    )}
                    <MDButton variant="gradient" color="info" type="submit">
                        Salvar
                    </MDButton>
                </MDBox>
            </MDBox>
            <Footer />
        </DashboardLayout >
    );
}

export default Settings;